<template>
  <div class="contaier">
    <page-header></page-header>
    <div class="max-box title-area">
      <div class="hq-title1">
        {{ carDetails.modelName }} {{ $t('public.configuration') }}
      </div>
    </div>
    <!-- {{ isClickScroll }} -->
    <div class="car-config-wrap">
      <!-- 快捷导航栏 -->
      <div class="nav-bar" v-if="showNav">
        <div
          :key="index"
          class="nav-chip"
          :class="{ 'nav-chip_ac': groupKey == group.key }"
          v-for="(group, index) in modelParam"
          @click="scrollToGroup(group.key)">
          {{ langShow(group.name1) }}
          <!-- {{ group.name }} -->
        </div>
      </div>
      <!-- 统一滚动容器 -->
      <div class="scroll-container" ref="scrollContainer">
        <div class="table-wrapper">
          <!-- 左侧固定列 -->
          <div class="left-fixed-col">
            <!-- 左侧表头 - 吸顶，与右侧车型表头对齐 -->
            <div
              class="left-header-sticky"
              :class="{ 'sticky-active': isLeftHeaderSticky }">
              <div class="car-name">{{ $t('homeP.models') }}</div>
            </div>
            <div
              :key="index2"
              class="group-section"
              v-for="(group, index2) in configList1"
              :data-group-key="group.key">
              <div
                class="group-title"
                :class="{ 'sticky-active': activeStickyKey === group.key }">
                {{ langShow(group.name1) }}
                <!-- {{ group.name }}3 -->
              </div>
              <div
                :key="i"
                class="param-item"
                v-for="(item, i) in group.items"
                :id="`param-item${index2}-${i}`">
                <!-- {{ item.name1 }}3 -->
                {{ langShow(item.name1) }}
                <!-- {{ item.name }}3 -->
              </div>
            </div>
          </div>

          <!-- 右侧车型区域 -->
          <div class="right-content">
            <div
              :key="car.key"
              v-for="car in defaultConfigList3"
              class="car-column">
              <!-- 车型名称表头 - 吸顶 -->
              <div
                class="car-name-header"
                :ref="`carHeader_${car.key}`"
                :class="{ 'sticky-active': activeCarHeaderKey === car.key }">
                <div class="car-name">{{ langShow(car.name1) }}</div>
                <!-- <div class="car-name">{{ car.name }}3</div> -->
              </div>

              <div
                :key="index"
                class="group-section"
                v-for="(item, index) in configList1">
                <div
                  class="group-title"
                  :class="{ 'sticky-active': activeStickyKey === item.key }">
                  &nbsp;
                  <!-- {{ item.name }} -->
                </div>
                <div
                  :key="paramIndex"
                  class="param-item"
                  :style="{ height: `${item2.H}px` }"
                  v-for="(item2, paramIndex) in item.items">
                  {{ getParamValue(car, item2) }}
                  <!-- getParamValue(car, item.key, item2.name) -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="note-hint" v-if="showHint">👆 {{ $t('public.swipe') }}</div>
    <div class="attentions">
      <div class="attention">{{ $t('public.note') }}：</div>
      <div>
        <span class="icon-standard">●</span>
        <span class="iconspan">{{ $t('public.standard') }}</span>
      </div>
      <div>
        <span class="icon-selection">O</span>
        <span class="iconspan">{{ $t('public.standard1') }}</span>
      </div>
      <div>
        <span class="icon-unuse">—</span>
        <span class="iconspan">{{ $t('public.standard3') }}</span>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import { debounce } from 'lodash'
// import { imgBase } from '@/assets/js/static'
import { EventBus } from '@/assets/js/event-bus'
import PageHeader from '@/components/PageHeader.vue'
import FooterPage from '@/components/FooterPage.vue'
import {
  modelDetailsApi,
  modelParameterApi,
  modelPropParameterApi,
} from '@/Api/requestApi'
// import { configList1, defaultConfigList3 } from '@/assets/js/static3'
import { langMixins } from '@/mixins/langMixins'
export default {
  name: 'ParamDetails',
  mixins: [langMixins],
  components: {
    PageHeader,
    FooterPage,
  },
  props: {
    showNav: {
      type: Boolean,
      default: true,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    maxHeight: {
      type: String,
      default: '100vh',
    },
  },
  data() {
    return {
      groupKey: 10001,
      activeStickyKey: null,
      scrollHandler: null,
      activeCarHeaderKey: null, // 当前吸顶的车型key
      isLeftHeaderSticky: false, // 左侧表头是否吸顶
      configList1: [],
      defaultConfigList3: [],
      id: 1,
      // configList1,
      // defaultConfigList3,
      modelParam: [],
      param: {},
      param2: {},
      versions: [],
      isClickScroll: false,
      carDetails: { id: '', modelName: '' },
    }
  },
  created() {
    EventBus.$on('message', this.receiveMessage)
  },
  mounted() {
    this.id = this.$route.query.id
    this.modelDetailsFn()
    this.getModelParameterFn()

    this.$nextTick(() => {
      window.addEventListener('resize', debounce(this.getHeight, 200))
      // this.langFn('/carDetails', this.$route?.query?.id)
    })

    this.langFn('/paramDetails', this.$route?.query?.id)
    this.getModelPropParam()

    const container = this.$refs.scrollContainer
    if (container) {
      // container.style.maxHeight = this.maxHeight
      // 监听滚动，高亮当前分组和当前车型表头
      this.scrollHandler = () => {
        const scrollTop = container.scrollTop

        // 1. 高亮当前分组
        const leftGroups = this.$el.querySelectorAll(
          '.left-fixed-col .group-section'
        )
        let activeKey = null

        for (let i = 0; i < leftGroups.length; i++) {
          const group = leftGroups[i]
          const offsetTop = group.offsetTop
          if (scrollTop + 60 >= offsetTop) {
            // 60是表头高度偏移
            activeKey = group.getAttribute('data-group-key')
          } else {
            break
          }
        }

        // console.log('activeKey :>> ', activeKey)

        this.activeStickyKey = activeKey

        // 2. 检测左侧表头是否吸顶（滚动超过左侧表头位置时）
        const leftHeader = this.$el.querySelector('.left-header-sticky')
        if (leftHeader) {
          // const headerRect = leftHeader.getBoundingClientRect()
          // const containerRect = container.getBoundingClientRect()
          // 当左侧表头滚动到顶部时，sticky 会自动生效，这里检测其相对位置
          this.isLeftHeaderSticky = scrollTop > 10
        }

        // 3. 高亮当前吸顶的车型表头
        const carHeaders = this.$el.querySelectorAll('.car-name-header')
        let activeCarKey = null

        for (let i = 0; i < carHeaders.length; i++) {
          const header = carHeaders[i]
          const rect = header.getBoundingClientRect()
          const containerRect = container.getBoundingClientRect()
          const headerTop = rect.top - containerRect.top

          // 当表头滚动到顶部附近时认为它应该吸顶
          if (headerTop <= 5 && headerTop > -60) {
            activeCarKey = this.defaultConfigList3[i]?.key
          }
          if (headerTop <= 0) {
            activeCarKey = this.defaultConfigList3[i]?.key
          }
        }

        // 如果没有找到活跃的（比如滚动到最底部），取最后一个
        if (
          !activeCarKey &&
          carHeaders.length > 0 &&
          scrollTop + container.clientHeight >= container.scrollHeight - 100
        ) {
          activeCarKey =
            this.defaultConfigList3[this.defaultConfigList3.length - 1]?.key
        }

        if (activeKey && !this.isClickScroll) {
          this.groupKey = activeKey
        }

        this.activeCarHeaderKey = activeCarKey
      }

      container.addEventListener('scroll', this.scrollHandler)
      this.scrollHandler()
    }

    // 为左侧分组设置 data-group-key
    this.$nextTick(() => {
      const leftSections = this.$el.querySelectorAll(
        '.left-fixed-col .group-section'
      )
      leftSections.forEach((sec, idx) => {
        const titleText =
          sec.querySelector('.group-title')?.innerText?.trim() || ''

        const mapping = this.param

        // const mapping = {
        //   车辆参数: 10001,
        //   外观配置: 10002,
        //   内饰配置: 10003,
        //   舒适安全配置: 10004,
        // }

        let realKey = mapping[titleText]
        if (!realKey && this.configList1[idx])
          realKey = this.configList1[idx].key
        if (realKey) sec.setAttribute('data-group-key', realKey)
      })
    })
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  beforeDestroy() {
    if (this.$refs.scrollContainer && this.scrollHandler) {
      this.$refs.scrollContainer.removeEventListener(
        'scroll',
        this.scrollHandler
      )
    }
    EventBus.$off('message', this.receiveMessage)
  },

  methods: {
    async modelDetailsFn() {
      const {
        data: { code, data },
      } = await modelDetailsApi({ id: this.$route.query.id })

      if (code == 200) {
        this.carDetails = {
          id: data.id,
          modelName: data.modelName,
        }
        console.log(' this.carDetails  :>> ', this.carDetails)
      }
    },
    async getModelParameterFn() {
      const {
        data: { code, data },
      } = await modelParameterApi({ id: '1' })
      if (code == 200) {
        console.log('data :>> ', data)
        let list_ = []

        let param_ = {}
        let param2_ = {}

        for (let i = 0; i < data.length; i++) {
          const { propt_id, prop_name, prop_nameEn } = data[i]
          this.versions.push(propt_id)
          param_ = { ...param_, [propt_id]: prop_name }
          param2_ = { ...param2_, [propt_id]: prop_nameEn }
          list_.push({
            key: propt_id,
            name1: { zh: prop_name, en: prop_nameEn },
          })
        }

        this.param = param_
        this.param2 = param2_
        // console.log('list_ :>> ', param_)
        // console.log('list2_ :>> ', param2_)
        console.log('list_ :>> ', list_)
        this.modelParam = list_
      }
    },
    getParamValue(car, paramLabel) {
      // console.log('item :>>44 ', item);
      // console.log('car :>> ', car)
      const targetGroup = car.Arr[0].items.find(
        g => g.prop_name == paramLabel.name
      )

      if (car.key === 10000) {
        // console.log('targetGroup :>> 2', targetGroup)
        return this.langShow(targetGroup.name1)
      } else {
        if (!targetGroup || !targetGroup.name) return '—'
        return targetGroup.name
      }
    },
    scrollToGroup(groupKey) {
      // console.log('groupKey :>> ', groupKey);
      this.groupKey = groupKey
      this.isClickScroll = true

      const container = this.$refs.scrollContainer
      if (!container) return

      const targetSection = this.$el.querySelector(
        `.left-fixed-col .group-section[data-group-key="${groupKey}"]`
      )
      if (targetSection) {
        container.scrollTo({
          top: targetSection.offsetTop - 54, // 减去表头高度
          behavior: 'smooth',
        })
      }

      let setT_ = setTimeout(() => {
        clearTimeout(setT_)
        this.isClickScroll = false
        console.log('setTimeout :>> ')
      }, 10000)
    },
    async getModelPropParam() {
      let id_ = this.$route.query.id
      const {
        data: { code, data, modelList },
      } = await modelPropParameterApi({
        // id: '2',
        // id: '1',
        id: id_,
      })

      // const titleMap = {
      //   10001: 'Vehicle Parameters',
      //   10002: 'Exterior Features',
      //   10003: 'Interior Features',
      //   10004: 'Convenience & Safety Features',
      // }
      // const titleMap2 = {
      //   10001: '车辆参数',
      //   10002: '外观配置',
      //   10003: '内饰配置',
      //   10004: '舒适安全配置',
      // }

      const titleMap = this.param2
      const titleMap2 = this.param

      // console.log('modelList :>> 888', JSON.parse(modelList[0].model_style))
      if (code == 200) {
        let mn_ = JSON.parse(modelList[0].model_style)

        let configList3 = [
          // {
          //   key: 10000,
          //   name: '我只是占位',
          //   name1: { zh: '我只是占位', en: '我只是占位' },
          //   Arr: [],
          // },
        ]

        for (let i = 0; i < mn_.length; i++) {
          const { car_model, car_modelEn } = mn_[i]
          configList3.push({
            key: 10001 + i,
            name: car_model,
            name1: { zh: car_model, en: car_modelEn },
            Arr: [],
          })
        }

        // configList3 = mn_.map((item, index) => ({
        //   key: 10001 + index,
        //   name: item.car_model,
        //   name1: { zh: item.car_model, en: item.car_modelEn },
        //   Arr: [],
        // }))
        // console.log('configList3 :>> ', configList3)
        // console.log('mn_ :>>444 ', mn_)
        // console.log('222222222222 :>> ', 222222222222);

        const versions = this.versions
        console.log('this.versions :>> ', this.versions)
        // const versions = ['10001', '10002', '10003', '10004']

        let config1 = []
        // for (let i = 0; i < versions.length; i++) {
        //   config1.push({
        //     key: versions[i],
        //     name: titleMap2[versions[i]],
        //     name1: { zh: titleMap2[versions[i]], en: titleMap[versions[i]] },
        //     items: [],
        //   })
        // }

        for (let key in data) {
          // console.log('data[key] :>> ', data[key])
          let list2 = data[key].filter(
            item => item.propt_id == versions[key - 1]
          )

          console.log('list2 :>> ', list2)

          let { prop_name, prop_nameEn, prop_valCttEn, propt_id } = list2[0]
          let arr_ = []

          arr_.push({
            prop_valCttEn,
            key: propt_id,
            n: { zh: prop_name, en: prop_nameEn },
            items: data[key].map(e => ({
              prop_name: e.prop_name,
              name: e.prop_valCttEn,
            })),
          })
          configList3[key - 1].Arr = arr_

          // let arr1_ = []
          // arr1_.push({
          //   prop_valCttEn,
          //   key: propt_id,
          //   n: { zh: prop_name, en: prop_nameEn },
          //   items: data[key].map(e => ({
          //     prop_name: e.prop_name,
          //     name: e.prop_nameEn,
          //     name1: { zh: e.prop_name, en: e.prop_nameEn },
          //   })),
          // })

          // configList3[0].Arr = arr1_

          // config1[key - 1].items = list2.map(e => ({
          //   H: null,
          //   name: e.prop_name,
          //   name1: { zh: e.prop_name, en: e.prop_nameEn },
          // }))
          if (key == 1) {
            for (let i = 0; i < versions.length; i++) {
              let list3 = data[key].filter(item => item.propt_id == versions[i])
              config1.push({
                key: versions[i],
                // name: titleMap2[versions[i]],
                name1: {
                  zh: titleMap2[versions[i]],
                  en: titleMap[versions[i]],
                },
                items: list3.map(e => ({
                  H: null,
                  name: e.prop_name,
                  name1: { zh: e.prop_name, en: e.prop_nameEn },
                })),
              })
            }
          }
        }

        console.log('configList3 :>> ', configList3)
        console.log('config1 :>> ', config1)

        this.defaultConfigList3 = configList3
        this.configList1 = config1
        // console.log('carConfig_ :>> ', carConfig_)
        // this.$nextTick(() => {
        setTimeout(() => {
          this.getHeight()
        }, 800)
        // })
      }
    },
    langShow(p) {
      // console.log('this.$i18n.locale :>> ', this.$i18n.locale)
      // console.log('object :>> ------------------', p)
      if (!p) {
        return ''
      }
      return p[this.$i18n.locale]
    },

    receiveMessage() {
      setTimeout(() => {
        this.getHeight()
      }, 800)
    },
    getHeight() {
      console.log('getHeight :>> ')
      let list_ = this.configList1
      let changeObj = { 84: 83.5, 71: 70.5, 123: 122.5 }
      // console.log('getHeight :>> ---------', list_)
      for (let i = 0; i < list_.length; i++) {
        for (let j = 0; j < list_[i].items.length; j++) {
          let elH =
            document.getElementById(`param-item${i}-${j}`)?.offsetHeight || 45
          // console.log('elH :>> ', elH)
          this.configList1[i].items[j].H = changeObj[elH] ? changeObj[elH] : elH
        }
      }
      // console.log(' this.configList1 :>> --',  this.configList1);
    },
  },
}
</script>

<style scoped lang="scss">
.contaier {
  .title-area {
    padding: 150px 20px 60px 20px;
  }
  .attentions {
    // padding-top: 10px;
    padding: 10px 20px 60px 20px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // padding-bottom: 60px;
    .iconspan {
      padding-left: 5px;
      // padding-right: 15px;
    }
    .attention {
      padding-right: 10px;
    }
  }
  .max-box {
    .hq-title1 {
      // padding: 60px 0;
      font-size: 32px;
    }
  }
}

.car-config-wrap {
  // width: 100%;
  max-width: 1200px;
  height: 70vh;
  margin: 0 auto;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  background: #ffffff;
  // border-radius: 20px;
  overflow: hidden;
  // border: 1px solid #eef2f8;
  // box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

/* 快捷导航栏 */
.nav-bar {
  // display: flex;
  // flex-wrap: wrap;
  // gap: 8px;
  // padding: 12px 6px;
  background: #ffffff;
  // border-bottom: 1px solid #eef2f8;
  // position: sticky;
  // top: 0;
  // border: #eff3f8 1px solid;
  // text-align: center;
  z-index: 30;
  .nav-chip {
    // background: #eff3f8;
    // border: none;
    padding: 12px 6px;
    // border-radius: 40px;
    font-size: 12px;
    font-weight: 500;
    color: #2c3e66;
    cursor: pointer;
    transition: 0.2s;
  }

  .nav-chip:active {
    background: #e0e8f4;
    transform: scale(0.96);
  }
}

/* 统一滚动容器 */
.scroll-container {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  height: 70vh;
  // padding-bottom: 36px;
}

/* 表格包装器 */
.table-wrapper {
  display: flex;
  min-width: max-content;
}

/* 左侧固定列 */
.left-fixed-col {
  flex-shrink: 0;
  // width: 240px;
  // width: 190px;
  width: 150px;
  // width: 130px;
  background: #ffffff;
  border-right: 1px solid #edf2f7;
  // z-index: 10;
  z-index: 22;
  position: sticky;
  left: 0;
  top: 0;
}

/* 左侧表头吸顶 */
.left-header-sticky {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #ffffff;
}

.left-header-sticky .car-name {
  border-bottom: 2px solid #eef2ff;
}

.left-header-sticky.sticky-active .car-name {
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 右侧内容区域 */
.right-content {
  display: flex;
}

/* 车型列 */
.car-column {
  width: 290px;
  // width: 140px;
  flex-shrink: 0;
  text-align: center;
  background: #fff;
  border-right: 1px solid #f0f2f8;
}

// .car-column:first-child {
//   width: 150px;
// }

.car-column:last-child {
  border-right: none;
}

/* 车型名称表头容器 - 吸顶 */
.car-name-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #ffffff;
}

.car-name-header.sticky-active .car-name {
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  // background: #ffffff;
}

/* 车型名称样式 */
.car-name {
  height: 56px;
  line-height: 56px;
  font-size: 14px;
  font-weight: 600;
  // color: #1e40af;
  background: #fafcff;
  border-bottom: 2px solid #eef2ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
}

.left-fixed-col .car-name {
  color: #1e293b;
  font-weight: 700;
  // background: #ffffff;
  text-align: left;
  padding-left: 16px;
  border-bottom: 2px solid #eef2ff;
}

/* 分组区域 */
.group-section {
  width: 100%;
}

/* 分组标题 */
.group-title {
  position: sticky;
  top: 56px; /* 表头高度，让分组标题在表头下方吸顶 */
  background-color: #f2f2f2;
  font-weight: 600;
  font-size: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #e9edf2;
  transition: all 0.15s;
  text-align: center;
  z-index: 15;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-fixed-col .group-title {
  text-align: left;
  padding-left: 16px;
  top: 56px;
  background-color: #f2f2f2;
}

.group-title.sticky-active {
  background-color: #f2f2f2;
  color: #000;
  // box-shadow: 0 1px 4px rgba(0, 94, 255, 0.1);
  font-weight: 600;
}

/* 参数行 */
.param-item {
  padding: 12px 8px;
  font-size: 13px;
  color: #1f2a3e;
  border-bottom: 1px solid #f0f2f6;
  min-height: 45px;
  // min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  background: #fff;
}

.left-fixed-col .param-item {
  justify-content: flex-start;
  // padding-left: 16px;
  font-weight: 500;
  width: 100%;
}

/* 底部提示 */
.note-hint {
  padding: 10px 10px 10px 260px;
  margin-bottom: 10px;
  font-size: 11px;
  text-align: center;
  // border-top: 1px solid #eef2f8;
  color: #6c7a8e;
  // background: #f8fafc;
}

/* 滚动条美化 */
.scroll-container::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #eef2f6;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
@media (min-width: 760px) {
  .contaier {
    .title-area {
      // padding-top: 150px;
      // padding-bottom: 60px;
    }
    .attentions {
      display: flex;
      justify-content: center;
      // align-items: center;
      .iconspan {
        // padding-left: 5px;
        padding-right: 20px;
      }
    }
    .max-box {
      .hq-title1 {
        // padding: 60px 0;
        // font-size: 32px;
      }
    }
  }

  .car-config-wrap {
    display: flex;
  }

  .nav-bar {
    width: 260px;
    max-height: 70vh;
    overflow-y: auto;
    // border: #eff3f8 1px solid;
  }
  .nav-chip:nth-child(n + 2) {
    border-top: #eef2f8 1px solid;
  }
  .nav-chip_ac {
    background-color: #24308f;
    color: #fff !important;
  }
}
/* 小屏适配 */
@media (max-width: 760px) {
  .contaier {
    .title-area {
      padding-top: 100px;
      padding-bottom: 30px;
      .hq-title1 {
        font-size: 16px;
      }
    }
  }
  /* 底部提示 */
  .note-hint {
    padding: 10px !important;
    // margin-bottom: 10px !important;
  }
  .nav-bar {
    width: 100%;
    display: flex;
    // width: fit-content;
    padding: 0 8px;
    overflow-x: auto;
    // margin-bottom: 30px;
    border-bottom: #fff solid 2px;

    .nav-chip {
      padding: 12px 12px;
      margin-bottom: 20px;
      white-space: nowrap;
      // border-color: #fff;
    }
  }

  .nav-bar::-webkit-scrollbar {
    width: 5px; /* 滚动条的宽度 */
    height: 5px; /* 滚动条的高度，对于横向滚动条来说，这通常是滚动条的厚度 */
  }

  /* 滚动条滑块 */
  .nav-bar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px; /* 滑块的圆角 */
  }

  /* 滚动条轨道 */
  .nav-bar::-webkit-scrollbar-track {
    background: #eef2f6;
  }

  .nav-chip_ac {
    border-bottom: #666 solid 2px;
  }
  .scroll-container {
    // overflow: auto;
    // -webkit-overflow-scrolling: touch;
    height: 100vh;
    // padding-bottom: 36px;
  }
  .car-config-wrap {
    // width: 100%;
    // max-width: 1200px;
    height: 100vh;
  }
}

/* 小屏适配 */
@media (max-width: 640px) {
  .left-fixed-col {
    // width: 118px;
  }
  // .car-column {
  //   width: 118px;
  // }
  .param-item {
    font-size: 11px;
    padding: 10px 4px;
  }
  .car-name {
    font-size: 12px;
  }
  .group-title {
    font-size: 11px;
    padding: 8px 0;
    top: 56px;
  }
  .left-fixed-col .param-item {
    padding-left: 10px;
  }
  .left-fixed-col .group-title {
    padding-left: 10px;
  }
  .nav-chip {
    padding: 5px 12px;
    font-size: 11px;
  }
}
</style>
